import { DateControlViewModel } from "../Models";
import BaseViewModel from "../Models/BaseViewModel";
import { EnumLiteralType } from "../Types";

type FileInfoType = {
    key: string;
    title: string;
    files: FileList;
    size?: number;
};

type FormAttachmentInfoType = {
    key: string;
    title: string;
    fileName: string | null;
};

class ViewModelDataCollector {

	static attachmentData: any;
	static fileInfos: Array<FileInfoType> = [];
	static formAttachments: Array<FormAttachmentInfoType> = [];

	static collectFormDataKoVm = ( model: BaseViewModel ) => {
		const root = model.getRootElement();
        // Обнуляем список файлов перед новым сбором данных,
        // чтобы не накапливать удалённые и дубликаты
        this.fileInfos = [];
		this.formAttachments = [];
		return this.collectCurrentElementDataFromKoVm( root );
	};

	static collectCurrentElementDataFromKoVm = ( currentElement: any, params?: any ) => {
		if ( currentElement === null) return null;

		if ( params?.parentInvisible === true ) {
			// Для DATE-полей в скрытых секциях берем DefaultValue/Calculation скрипт
			// Это нужно когда аналитик поставил DateTime.Now как дефолт, но секция скрыта
			if ( currentElement.DescriptorKey === "DateControlDescriptor" ) {
				if ( currentElement.Value ) {
					return currentElement.getValue ? currentElement.getValue() : currentElement.Value;
				}
				const script = currentElement.DefaultValueScript ?? currentElement.CalculationScript;
				if ( script?.canLaunchScript?.() ) {
					const defaultVal = script.runScript();
					if ( defaultVal != null ) {
						currentElement.setValue?.(defaultVal);
						return currentElement.getValue ? currentElement.getValue() : null;
					}
				}
			}
			return null;
		}
		
		if ( currentElement.Pages ) {
			//Вкладки
			const pageElementsKoData: any = {};
			for (let index = 0; index < currentElement.Pages.length; index++) {
				const page = currentElement.Pages[index];
				for (let index = 0; index < page.PageElements.length; index++) {
					const element = page.PageElements[index];
					const elePath: string = element.Path;
					const realPath = elePath.substring(elePath.lastIndexOf('.') + 1);
					const elementValue = ViewModelDataCollector.collectCurrentElementDataFromKoVm(element, params);
					if ( elementValue !== null ) {
						pageElementsKoData[realPath] = elementValue;
					}
				}
			}
			return pageElementsKoData;
		} 
		else if ( currentElement.FormElements ) {
			// Форма!
			const elementsKoData: any = {};
			const isVisible = typeof currentElement.IsControlVisible === "function" ? currentElement.IsControlVisible() : true;
			
			for ( let index = 0; index < currentElement.FormElements.length; index++ ) {
				const element = currentElement.FormElements[index];
				const elePath: string = element.Path;
				const realPath = elePath.substring(elePath.lastIndexOf('.') + 1);
				
				const childParams = isVisible ? params : { ...params, parentInvisible: true };
				const elementValue = ViewModelDataCollector.collectCurrentElementDataFromKoVm(element, childParams);
				elementsKoData[realPath] = elementValue;
			}
			return elementsKoData;
		} 
		else if ( currentElement.CollectionItems ) {
			//коллекция
			const colElementsKoData = [];
			for (let inde = 0; inde < currentElement.CollectionItems.length; inde++) {
				const innerElements: any = {};
				for (let index = 0; index < currentElement.CollectionItems[inde].FormElements.length; index++) {
					const element = currentElement.CollectionItems[inde].FormElements[index];
					const elePath = element.Path;
					const realPath = elePath.substr(elePath.lastIndexOf('.') + 1);
					if ( !!params ) {
						params.targetElement = currentElement;//.element();
					}
					const elementValue = ViewModelDataCollector.collectCurrentElementDataFromKoVm(element, params);
					if ( elementValue !== null ) {
						innerElements[realPath] = elementValue;
					}
				}
				colElementsKoData.push(innerElements);
			}
			return colElementsKoData;
		}
		// ФИАС.
		if (currentElement.DescriptorKey === 'FiasRegionSelectControlViewModel' || currentElement.DescriptorKey === 'FIAS') {
			const fiasValue = currentElement.getValue();
			if ( !fiasValue ) return null;
			const fiasKeys = Object.keys(fiasValue);
			const resultFiasValue: any = {};
			for ( let i = 0; i < fiasKeys.length; i++ ) {
				if ( !!fiasValue[fiasKeys[i]] ) {
					resultFiasValue[fiasKeys[i]] = fiasValue[fiasKeys[i]];
				}
			}
			return resultFiasValue;
		}

		// Виджет выбора участника
		if (currentElement.typeId === 'UserInfoList') {
			if (!currentElement.Value) return null;
			return {
				'CredentialHash': currentElement.Value,
				'UserName': currentElement.element.children[0].selectedOptions.item(0).text
			};
		}

		// Выбор заявителя
		if (currentElement.typeId === 'CustomerSelect') {
			if (currentElement.Value == null)
				return null;
			return {
				'RecId': currentElement.valueId,
				'CustomerType': currentElement.Value.customerType,
				'FirstName': currentElement.Value.physicalName != null ? currentElement.Value.physicalName.first : null,
				'LastName': currentElement.Value.physicalName != null ? currentElement.Value.physicalName.last : null,
				'MiddleName': currentElement.Value.physicalName != null ? currentElement.Value.physicalName.middle : null,
				'Snils': currentElement.Value.snils,
				'Inn': currentElement.Value.inn,
				'BirthDate': currentElement.Value.birthDate,
				'PassportSeries': currentElement.Value.physicalPassport != null ? currentElement.Value.physicalPassport.series : null,
				'PassportNumber': currentElement.Value.physicalPassport != null ? currentElement.Value.physicalPassport.number : null,
				'Phone1': currentElement.Value.contacts != null ? currentElement.Value.contacts.phone1 : null,
				'Phone2': currentElement.Value.contacts != null ? currentElement.Value.contacts.phone2 : null,
				'Phone3': currentElement.Value.contacts != null ? currentElement.Value.contacts.phone3 : null,
				'Email': currentElement.Value.contacts != null ? currentElement.Value.contacts.email : null,
				'Citizenship': currentElement.Value.citizenship,
				'DisplayName': currentElement.Value.displayName,
				'DisplayDocType': currentElement.Value.displayDocType,
				'Ogrn': currentElement.Value.ogrn,
				'Country': currentElement.Value.country,
				'CompanyFullName': currentElement.Value.companyFullName,
				'CompanyShortName': currentElement.Value.companyShortName,
				'Kpp': currentElement.Value.kpp,
				'DirectorPost': currentElement.Value.directorPost,
				'DirectorFirstName': currentElement.Value.directorName != null ? currentElement.Value.directorName.first : null,
				'DirectorLastName': currentElement.Value.directorName != null ? currentElement.Value.directorName.last : null,
				'DirectorMiddleName': currentElement.Value.directorName != null ? currentElement.Value.directorName.middle : null,
				'RepresentativeFirstName': currentElement.Value.representativeName != null ? currentElement.Value.representativeName.first : null,
				'RepresentativeLastName': currentElement.Value.representativeName != null ? currentElement.Value.representativeName.last : null,
				'RepresentativeMiddleName': currentElement.Value.representativeName != null ? currentElement.Value.representativeName.middle : null,
				'OkopfCode': currentElement.Value.okopfCode,
				'OkopfName': currentElement.Value.okopfName
			};
		}

		// SimpleAttachment
        if ( currentElement.DescriptorKey === "SimpleAttachmentViewModel" ) {
            const rawKey = currentElement.FullPath || currentElement.LocalPath;
            const fullKey = (typeof rawKey === "string" && rawKey.startsWith("_."))
                ? rawKey.substring(2)
                : rawKey;

            if ( currentElement?.isCleared === true ) {
                const storedClean = typeof currentElement?.getCleanValue === 'function'
                    ? currentElement.getCleanValue()
                    : '';
                const initialName = typeof currentElement?.initialFileName === "string" ? currentElement.initialFileName : '';
                const wasFilled = !!(storedClean || initialName);
                if ( wasFilled ) {
                    ViewModelDataCollector.formAttachments.push({
                        key: fullKey,
                        title: currentElement.Caption,
                        fileName: null
                    });
                }
                return null;
            }

            if ( typeof currentElement.Value === "string" && currentElement.Value ) {
                const fileName = currentElement.Value;
                ViewModelDataCollector.formAttachments.push({
                    key: fullKey,
                    title: currentElement.Caption,
                    fileName
                });
                return fileName;
            }

            if ( currentElement.Value && typeof currentElement.Value === "object" && typeof currentElement.Value.length === "number" && currentElement.Value.length ) {
                const file0 = currentElement.Value[0];
                const fileName = file0?.name?.replace?.("C:\\fakepath\\", "") ?? file0?.name;
                ViewModelDataCollector.fileInfos.push( {
                    key: fullKey,
                    title: currentElement.Caption,
                    files: currentElement.Value,
                    size: (file0?.size > 0) ? file0.size : undefined
                });
                ViewModelDataCollector.formAttachments.push({
                    key: fullKey,
                    title: currentElement.Caption,
                    fileName: fileName || null
                });
                return fileName ? fileName : null;
            }

            const storedClean = typeof currentElement?.getCleanValue === 'function'
                ? currentElement.getCleanValue()
                : '';
            const initialName = typeof currentElement?.initialFileName === "string" ? currentElement.initialFileName : '';
            const fallbackName = storedClean || initialName;

            if ( !fallbackName ) {
                return null;
            }
            ViewModelDataCollector.formAttachments.push({
                key: fullKey,
                title: currentElement.Caption,
                fileName: fallbackName
            });
            return fallbackName;
        }

		if ( currentElement.DescriptorKey === "DateControlDescriptor" ) {
			const dateModel = currentElement as DateControlViewModel;
			if ( !!dateModel.Value ) {
				return dateModel.getValue();
			}
			return null;
		}

		if ( currentElement.selectedValueS2 !== undefined ) {
			// Передаём UnderlineValue, так как для значений вида 00033333333333333 в literalValue будет ошибка
			let s2Result: any = "";
			const options = Array.isArray(currentElement.options) ? currentElement.options : [];
			const hasOptions = options.length > 0;
			//for multiselect
			if ( currentElement.multiflag ) {
				const outdata = currentElement.selectedValueS2;
				const preResult = typeof outdata === 'string' ? [outdata] : outdata;
				if (currentElement.DictionaryId != null)
					return preResult;
				const endResult = [];

				for ( let i = 0; i < preResult.length; i++) {
					if (preResult[i] == null)
						break;
					for ( let j = 0; j < options.length; j++) {
						if (options[j].LV === preResult[i]) {
							if ( currentElement.isSave )
								endResult.push({
									enumId: options[j].UV,
									enumValue: options[j].UV,
									enumTitle: options[j].DA
								});
							else
								endResult.push(options[j].UV);
							break;
						}
					}
				}
				return endResult;
			}

			options.forEach( ( data: EnumLiteralType ) => {
				if (data.LV === currentElement.selectedValueS2 ) {
					if ( currentElement.isSave )
						s2Result = { enumId: data.UV, enumValue: data.UV, enumTitle: data.DA };
					else
						s2Result = data.UV;
				}
			});

			if ( s2Result === "" && hasOptions && currentElement.DescriptorKey === "EnumControlDescriptor" ) {
				return null;
			}

			return s2Result === "" ? currentElement.selectedValueS2 : s2Result;
		}

		if ( currentElement.Parent ) {
			let parent = currentElement.Parent;
			while ( parent ) {
				if ( typeof parent.IsControlVisible === "function" && parent.IsControlVisible() === false ) {
					return null;
				}
				parent = parent.Parent;
			}
		}

		// Остальные элементы.
		if ( !!currentElement.Value ) {
			if ( currentElement.Value === "" ) return null;

			//это специально для float
			if (typeof (currentElement.Value) === "string") {
				if ( currentElement.ControlKey === "FloatControlDescriptor" )
					return currentElement.Value.replace(',', '.').trim();
				else
					return currentElement.Value.trim();
			} 
			else {
				return currentElement.Value.toString();
			}
		} 
		else {
			return null;
		}
	};

	// collect simple format data (xml view)
	static collectCurrentElementSimpleFormatDataFromKoVm = ( currentElement: any ) => {
		if ( currentElement === null ) return "";
		if ( currentElement.IsControlVisible === false ) return "";
		if ( !!currentElement.Pages ) {
			// Вкладки
			let pageElementsKoData: any = "";
			
			for (let pageid = 0; pageid < currentElement.Pages.length; pageid++) {
				const page = currentElement.Pages[pageid];
				pageElementsKoData += page.getSimpleFormatXmlOpen(pageid);
				for (let index = 0; index < page.PageElements.length; index++) {
					const element = page.PageElements[index];
					pageElementsKoData += this.collectCurrentElementSimpleFormatDataFromKoVm(element);
				}
				pageElementsKoData += page.getSimpleFormatXmlClose();
			}

			return pageElementsKoData;
		} 
		else if (currentElement.FormElements) {
			// Форма!
			let elementsKoData = '';
			if (currentElement.IsControlVisible() === true) {
				elementsKoData = currentElement.getSimpleFormatXmlOpen();
				for (let index = 0; index < currentElement.FormElements.length; index++)
					elementsKoData += this.collectCurrentElementSimpleFormatDataFromKoVm(currentElement.FormElements[index]);
				elementsKoData += currentElement.getSimpleFormatXmlClose();
			}
			return elementsKoData;
		} 
		else if (currentElement.CollectionItems && typeof currentElement.CollectionItems == "function") {
			// коллекция
			let colElementsKoData = currentElement.getSimpleFormatXmlOpen();
			for ( let inde = 0; inde < currentElement.CollectionItems().length; inde++) {
				let innerElements = '<Item>';
				currentElement.CollectionItems[inde].FormElements.forEach( ( element: any ) => {
					innerElements += this.collectCurrentElementSimpleFormatDataFromKoVm(element);
				});
				innerElements += '</Item>';
				colElementsKoData += innerElements;
			}
			if ( currentElement.CollectionItems.length === 0 ) {
				colElementsKoData += '<Item>';
				for (let index3 = 0; index3 < currentElement.itemToAdd.FormElements.length; index3++)
					colElementsKoData += this.collectCurrentElementSimpleFormatDataFromKoVm(currentElement.itemToAdd.FormElements[index3]);
				colElementsKoData += '</Item>';
			}
			colElementsKoData += currentElement.getSimpleFormatXmlClose();
			return colElementsKoData;
		}
		if (currentElement.IsControlVisible() !== true) {
			return '';
		}

		// ФИАС.
		if ( currentElement.DescriptorKey === 'FiasRegionSelectControlViewModel' || currentElement.DescriptorKey === 'FIAS' ) {
			return currentElement.getSimpleFormatXmlOpen() + currentElement.getStringValue()
				.replace(/&/gm, '&amp;')
				.replace(/"/gm, '&quot;')
				.replace(/</gm , '&lt;')
				.replace(/>/gm , '&gt;').replace(/'/gm , '&apos;') + currentElement.getSimpleFormatXmlClose();
		}

		// Виджет выбора участника
		if ( currentElement.DescriptorKey === 'UserInfoList' ) {
			if ( currentElement.Value === null )
				return currentElement.getSimpleFormatXmlOpen() + currentElement.getSimpleFormatXmlClose();
			return currentElement.getSimpleFormatXmlOpen() + currentElement.element().children[0].selectedOptions.item(0).text + currentElement.getSimpleFormatXmlClose();
		}

		if ( currentElement.DescriptorKey === 'CustomerSelect' ) {
			if (currentElement.Value === null)
				return currentElement.getSimpleFormatXmlOpen() + currentElement.getSimpleFormatXmlClose();
			return currentElement.getSimpleFormatXmlOpen() + currentElement.element().children[0].selectedOptions.item(0).text + currentElement.getSimpleFormatXmlClose();
		}

		// SimpleAttachment
		if ( currentElement.DescriptorKey === "SimpleAttachmentViewModel" ) {
			const value = currentElement.previousExist === true ? currentElement.certificateFileName : currentElement.getCleanValue();
			return currentElement.getSimpleFormatXmlOpen() + value + currentElement.getSimpleFormatXmlClose();
		}



		// Остальные элементы.
		if ( !!currentElement.Value ) {
			if (currentElement.Value === "")
				return currentElement.getSimpleFormatXmlOpen() + currentElement.getSimpleFormatXmlClose();

			// это специально для float
			if (typeof (currentElement.Value) === "string") {
				if ( currentElement.ControlKey === "FloatControlDescriptor" ) {
					return currentElement.getSimpleFormatXmlOpen() +
						currentElement.Value.replace(',', '.') +
						currentElement.getSimpleFormatXmlClose();
				} 
				else {
					return currentElement.getSimpleFormatXmlOpen() + currentElement.Value
						.replace(/"/g, '&quot;')
						.replace('<', '&lt;')
						.replace('>', '&gt;') + currentElement.getSimpleFormatXmlClose();
				}
			} 
			else {
				return currentElement.getSimpleFormatXmlOpen() + currentElement.Value + currentElement.getSimpleFormatXmlClose();
			}
		} 
		else if ( currentElement.selectedValueS2 !== undefined ) {
			// Передаём UnderlineValue, так как для значений вида 00033333333333333 в literalValue будет ошибка
			let s2Result = "";
			//for multiselect
			if ( currentElement.multiflag === true ) {
				const outdata = currentElement.selectedValueS2;
				const preResult = typeof outdata === 'string' ? [outdata] : outdata;
				if (currentElement.DictionaryId != null) {
					return currentElement.getSimpleFormatXmlOpen() + preResult + currentElement.getSimpleFormatXmlClose();
				}
				let endResult = "";
				for (let i = 0; i < preResult.length; i++) {
					if (preResult[i] == null)
						break;
					for (let j = 0; j < currentElement.options.length; j++) {
						if (currentElement.options[j].LV === preResult[i]) {
							endResult += currentElement.options[j].DA + '; ';
							break;
						}
					}
				}
				return currentElement.getSimpleFormatXmlOpen() + endResult.trim().substring(0, endResult.trim().length - 1) + currentElement.getSimpleFormatXmlClose();
			}

			currentElement.options.forEach( ( data: EnumLiteralType ) => {
				if (data.LV === currentElement.selectedValueS2)
					s2Result = data.DA;
			});

			return currentElement.getSimpleFormatXmlOpen() + (s2Result === "" ? currentElement.selectedValueS2 : s2Result) + currentElement.getSimpleFormatXmlClose();
		} 
		else {
			return currentElement.getSimpleFormatXmlOpen() + currentElement.getSimpleFormatXmlClose();
		}
	};

	/** Сброс */
	static reset = () => {
		this.attachmentData = null;
		this.fileInfos = [];
		this.formAttachments = [];
	};
};

export default ViewModelDataCollector;
